module.exports = __webpack_public_path__ + "static/media/Imagen 8.b02cf2e0.jpg";